import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type UserState = {
    loginBeganEmail?: string;
    didManuallyLogOut: boolean;
};

const initialState: UserState = {
    didManuallyLogOut: false,
};

const UserSlice = createSlice({
    name: "userInformation",
    initialState,
    reducers: {
        beginLogin: (state, action: PayloadAction<string>) => {
            state.loginBeganEmail = action.payload;
        },
        completeLogin: () => {
            return initialState;
        },
        setDidManuallyLogOut: (state, action: PayloadAction<boolean>) => {
            state.didManuallyLogOut = action.payload;
        },
    },
});

export const { beginLogin, completeLogin, setDidManuallyLogOut } = UserSlice.actions;
export default UserSlice.reducer;
